<ng-container>
  <router-outlet />
  <p-toast position="bottom-center" preventOpenDuplicates="true" />
  <app-screen-notification />
  <app-a2hs-notification />
</ng-container>

@if (secureSessionDialogVisible()) {
  <app-secure-session-dialog [(visible)]="secureSessionDialogVisible" />
}

@if (introductionDialogVisible()) {
  <app-introduction-dialog [(visible)]="introductionDialogVisible" />
}
